import React from "react";

const Home = () => {
    return <div>Hello World Home</div>;
};

export default Home;
